import { Sticky_Delta_Strike_LABELS } from "constants/generalActionButtons";
import StickyStrikeTable from "./StickyStrikeTable";

function StickyStrikeContainer({ currentTab, dateTime }) {
  if (currentTab === Sticky_Delta_Strike_LABELS.STICKY_DELTA.key) return;
  return (
    <div className="py-2 px-3">
      <StickyStrikeTable dateTime={dateTime} />
    </div>
  );
}

export default StickyStrikeContainer;
